import { GridColumnConfiguration } from '@nirvana/shared/dtos/types/shared/grid';

export enum GridSettingsEvents {
  SIDE_PANEL_SETTINGS_UPDATED = 'settingsUpdated',
  SETTINGS_UPDATED = 'allGridSettingsUpdated',
  RESET_VIEW = 'resetView',
}

export interface GridSettings<Column> {
  selectedColumns?: Array<Column>;
  isCompactViewChecked?: boolean;
  pageSize?: number;
  pageNumber?: number;
  columnConfigs?: Array<GridColumnConfiguration>;
  hasSelectableRows?: boolean;
}
